/**
 * Example JavaScript singleton module
 */

var Thumbnails = (function($) {
  function initThumbnails() {
    console.log("Thumbnails");
    console.log("Miau");
    const videos = document.querySelectorAll(".js-project-video");

    console.log("videos encontrados:", videos.length);

    videos.forEach((video, i) => {
      const posterTime = parseFloat(video.dataset.posterTime);
      console.log(`video ${i + 1} posterTime:`, posterTime);

      if (isNaN(posterTime)) {
        console.log(`video ${i + 1}: sin posterTime válido`);
        return;
      }

      const currentPoster = video.getAttribute("poster");
      console.log(`video ${i + 1} currentPoster:`, currentPoster);

      const source = video.querySelector("source");
      console.log(`video ${i + 1} source element:`, source);

      if (!source) {
        console.log(`video ${i + 1}: sin source`);
        return;
      }

      const src = source.getAttribute("src");
      console.log(`video ${i + 1} src:`, src);

      if (!src) {
        console.log(`video ${i + 1}: source sin src`);
        return;
      }

      const tempVideo = document.createElement("video");
      tempVideo.muted = true;
      tempVideo.playsInline = true;
      tempVideo.crossOrigin = "anonymous";
      tempVideo.preload = "metadata";
      tempVideo.src = src;

      tempVideo.addEventListener("loadedmetadata", () => {
        console.log(
          `video ${i + 1}: loadedmetadata`,
          tempVideo.duration,
          tempVideo.videoWidth,
          tempVideo.videoHeight
        );

        const safeTime = Math.min(
          Math.max(0, posterTime),
          Math.max(0, tempVideo.duration - 0.1)
        );

        console.log(`video ${i + 1}: seeking to`, safeTime);
        tempVideo.currentTime = safeTime;
      });

      tempVideo.addEventListener("seeked", () => {
        console.log(`video ${i + 1}: seeked at`, tempVideo.currentTime);

        try {
          const canvas = document.createElement("canvas");
          canvas.width = tempVideo.videoWidth;
          canvas.height = tempVideo.videoHeight;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(tempVideo, 0, 0, canvas.width, canvas.height);

          const dataURL = canvas.toDataURL("image/jpeg", 0.85);
          console.log(`video ${i + 1}: poster generado`);

          if (!isSafariDesktop()) {
            video.setAttribute("poster", dataURL);

            // Forzar refresh visual solo fuera de Safari desktop
            video.load();
          }

          console.log(`video ${i + 1}: poster aplicado`);
        } catch (e) {
          console.log(`video ${i + 1}: error canvas/poster`, e);
        }
      });

      tempVideo.addEventListener("error", e => {
        console.log(`video ${i + 1}: error tempVideo`, e, tempVideo.error);
      });
    });
  }

  function isSafariDesktop() {
    const ua = navigator.userAgent.toLowerCase();

    return (
      ua.includes("safari") &&
      !ua.includes("chrome") &&
      !ua.includes("android") &&
      !/iphone|ipad|ipod/.test(ua)
    );
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".single-project").length) {
      return;
    }

    initThumbnails();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Thumbnails.init);
